import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {AngularFireAuth} from '@angular/fire/auth'
import {AngularFirestore} from '@angular/fire/firestore'
import { isNullOrUndefined } from 'util';
import {map} from "rxjs/operators";
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private auth:AngularFireAuth,private db:AngularFirestore,private router:Router){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.auth.authState.pipe(map(auth=>{
   	  		
        if (auth==null || auth==undefined) {
          return true;
        } else {
          this.router.navigate(['/principal']);
          return false;
        }
   	  }))
  }
  
}
